import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import './index.scss';
import {ContextProvider} from './Context';
import {
  RouterProvider,
} from "react-router-dom";
import routerBrowser from './routes';
import { ConfigProvider, message } from 'antd';
import { installStatusMessageAnnouncements } from './functions/functions';

installStatusMessageAnnouncements(message);

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <ConfigProvider
    theme={{
      token: {
        colorText: '#1f2937',
        colorLink: '#0b3ea8',
        colorLinkHover: '#0a357f',
        colorLinkActive: '#082a66',
        colorError: '#b42318',
        colorErrorHover: '#912018',
        colorErrorActive: '#7a1a15',
      },
      components: {
        Steps: {
          colorText: '#1f2937',
          colorTextDescription: '#1f2937',
          colorTextLabel: '#1f2937',
        },
      },
    }}
  >
	<ContextProvider>
		<RouterProvider router={routerBrowser} />
	</ContextProvider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
